import { kilobaApi, eventApi } from './api';
import { ApiResponse } from '../types';

export interface GameCompletionResult {
  success: boolean;
  energyEarned: number;
  remainingAttempts: number;
  message: string;
  requiredScore?: number;
  score?: number;
}

export class GameService {
  /**
   * Complete Kiloba Racing game and submit score
   */
  static async completeRacingGame(score: number): Promise<GameCompletionResult | null> {
    try {
      const response = await kilobaApi.completeRacingGame(score);
      
      if (response.success && response.data) {
        return {
          success: response.data.success,
          energyEarned: response.data.energyEarned,
          remainingAttempts: response.data.remainingAttempts,
          message: response.data.message,
          requiredScore: response.data.session.requiredScore,
          score: response.data.session.score
        };
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  /**
   * Complete Kiloba Racing game for event session
   */
  static async completeEventRacingGame(gameSessionId: string, score: number): Promise<GameCompletionResult | null> {
    console.log('🎯 GameService.completeEventRacingGame called with:', { gameSessionId, score });
    try {
      const response = await eventApi.submitEventScore(gameSessionId, score);
      console.log('📡 Event API response:', response);
      
      if (response.success && response.data) {
        return {
          success: response.data.success,
          energyEarned: 0, // Events may have different reward structure
          remainingAttempts: 0, // Events may not have attempt limits
          message: response.data.message,
          score: score
        };
      } else {
        console.error('Failed to complete event racing game:', response.message);
        return null;
      }
    } catch (error) {
      console.error('Error completing event racing game:', error);
      return null;
    }
  }

  /**
   * Complete Kiloba 9 Clouds game and submit score
   */
  static async complete9CloudsGame(score: number): Promise<GameCompletionResult | null> {
    try {
      const response = await kilobaApi.complete9CloudsGame(score);
      
      if (response.success && response.data) {
        return response.data;
      } else {
        console.error('Failed to complete 9 clouds game:', response.message);
        return null;
      }
    } catch (error) {
      console.error('Error completing 9 clouds game:', error);
      return null;
    }
  }

  /**
   * Show game completion message to user
   */
  static showCompletionMessage(result: GameCompletionResult): string {
    if (result.energyEarned > 0) {
      return `🎉 Chúc mừng!\nNăng lượng nhận được: +${result.energyEarned}\n\nLượt chơi còn lại hôm nay: ${result.remainingAttempts}`;
    } else {
      return `${result.message}\nLượt chơi còn lại hôm nay: ${result.remainingAttempts}`;
    }
  }

  /**
   * Check if user can play game based on daily limits
   */
  static canPlayGame(remainingPlays: number): boolean {
    return remainingPlays > 0;
  }
}
